import { CustomAvatarProps } from '@ketch-com/deck'
import { TrackerListItemOrigin } from '@ketch-com/windlass/dist/dataSentry/v1/trackers/trackers'

export const avatarIconByOrigin: Record<TrackerListItemOrigin, CustomAvatarProps['icon']> = {
  [TrackerListItemOrigin.TRACKER_ORIGIN_FIRST_PARTY]: 'FCookie',
  [TrackerListItemOrigin.TRACKER_ORIGIN_THIRD_PARTY]: 'OCookie',
  [TrackerListItemOrigin.TRACKER_ORIGIN_MIXED]: 'FMixedCookie',
  [TrackerListItemOrigin.TRACKER_ORIGIN_UNSPECIFIED]: 'FUnknown',
}

export const originCopy: Record<TrackerListItemOrigin, string> = {
  [TrackerListItemOrigin.TRACKER_ORIGIN_FIRST_PARTY]: '1st Party',
  [TrackerListItemOrigin.TRACKER_ORIGIN_THIRD_PARTY]: '3rd Party',
  [TrackerListItemOrigin.TRACKER_ORIGIN_MIXED]: 'Mixed',
  [TrackerListItemOrigin.TRACKER_ORIGIN_UNSPECIFIED]: 'Unknown',
}
